import { render } from "./HPStatusComponent.vue?vue&type=template&id=b70459c8"
import script from "./HPStatusComponent.vue?vue&type=script&lang=js"
export * from "./HPStatusComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__